var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0016 16.8604V18.8904C11.0016 20.6104 9.40158 22.0004 7.43158 22.0004C5.46158 22.0004 3.85156 20.6104 3.85156 18.8904V16.8604C3.85156 18.5804 5.45158 19.8004 7.43158 19.8004C9.40158 19.8004 11.0016 18.5704 11.0016 16.8604Z",
    stroke: "#155a9e",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 14.11C10.9998 14.61 10.8598 15.07 10.6198 15.47C10.0298 16.44 8.8198 17.05 7.4198 17.05C6.0198 17.05 4.80979 16.43 4.21979 15.47C3.97979 15.07 3.83984 14.61 3.83984 14.11C3.83984 13.25 4.23982 12.48 4.87982 11.92C5.52982 11.35 6.41979 11.01 7.40979 11.01C8.39979 11.01 9.28982 11.36 9.93982 11.92C10.5998 12.47 10.9998 13.25 10.9998 14.11Z",
    stroke: "#155a9e",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0016 14.11V16.86C11.0016 18.58 9.40158 19.8 7.43158 19.8C5.46158 19.8 3.85156 18.57 3.85156 16.86V14.11C3.85156 12.39 5.45158 11 7.43158 11C8.42158 11 9.31161 11.35 9.96161 11.91C10.6016 12.47 11.0016 13.25 11.0016 14.11Z",
    stroke: "#155a9e",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2502 10.97V13.03C22.2502 13.58 21.8102 14.03 21.2502 14.05H19.2902C18.2102 14.05 17.2202 13.26 17.1302 12.18C17.0702 11.55 17.3102 10.96 17.7302 10.55C18.1002 10.17 18.6102 9.95001 19.1702 9.95001H21.2502C21.8102 9.97001 22.2502 10.42 22.2502 10.97Z",
    stroke: "#155a9e",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.5V8.5C2.25 5.78 3.89 3.88 6.44 3.56C6.7 3.52 6.97 3.5 7.25 3.5H16.25C16.51 3.5 16.76 3.50999 17 3.54999C19.58 3.84999 21.25 5.76 21.25 8.5V9.95001H19.17C18.61 9.95001 18.1 10.17 17.73 10.55C17.31 10.96 17.07 11.55 17.13 12.18C17.22 13.26 18.21 14.05 19.29 14.05H21.25V15.5C21.25 18.5 19.25 20.5 16.25 20.5H13.75",
    stroke: "#155a9e",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/walletMoney.49e633e3eccc1ba8c7fdf2b8874d23e7.svg";
export { ForwardRef as ReactComponent };